import { createConnectTransport } from "@connectrpc/connect-web";

import {
  getAuthorizationHeaderValue,
  getPersistedSelectedCompanyId,
} from "../shared/lib/authSession";
import { apiBaseUrl } from "./apiBaseUrl";
import { tokenRefreshInterceptor } from "./refreshInterceptor";

export const transport = createConnectTransport({
  baseUrl: apiBaseUrl,
  useBinaryFormat: false,
  // Ordered outermost-first. The refresh interceptor wraps the header one so a
  // retried request is given the token the refresh just stored.
  interceptors: [
    tokenRefreshInterceptor(),
    (next) => async (req) => {
      const authHeader = getAuthorizationHeaderValue();
      if (authHeader) req.header.set("Authorization", authHeader);

      const orgId = getPersistedSelectedCompanyId();
      if (orgId) req.header.set("x-organization-id", String(orgId));

      return next(req);
    },
  ],
});
